// Exports
export default {
	"Unsupported_container": "Unsupported_container_lf6TR",
	"containerWithoutHeaderAndFooter": "containerWithoutHeaderAndFooter_NLN9i",
	"Unsupported_title": "Unsupported_title_dD5uT",
	"Unsupported_subtitle": "Unsupported_subtitle_zCnoc"
};
